<template>
  <div id="payment-summary-item">
    <div class="item-container">
      <div class="item">
        <div class="item-name" :class="{ skeleton: loading }">{{ itemName }}</div>
        <div v-if="!itemNameInfoAtBottom">
            <div
              class="item-name-info"
              :class="{ skeleton: loading }"
              v-html="itemNameInfo"
            />
        </div>
      </div>
      <div class="item">
        <div class="item-value" :class="{ skeleton: loading }">{{ value }}</div>
        <div class="item-value-info" :class="{ skeleton: loading }">{{ valueInfo }}</div>
      </div>
    </div>
    <div v-if="itemNameInfoAtBottom">
        <div
          class="item-name-info"
          :class="{ skeleton: loading }"
          v-html="itemNameInfo"
        />
    </div>
  </div>
</template>

<script>
export default {
  name: 'payment-summary-item',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    itemName: {
      type: String,
    },
    itemNameInfo: {
      type: String,
    },
    itemNameInfoAtBottom: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
    },
    valueInfo: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
#payment-summary-item {
  border-radius: 1px;

  &:nth-child(n+2) {
    border-top: 1px solid var(--gray-200);
  }
}

.item-container {
  padding: 16px 0;
  display: flex;
  justify-content: space-between;

  @media (max-width: $md) {
    padding: 12px 0;
  }
}
.item-name {
  @extend .body-regular;
  @extend .gray-600;
}

.item-name-info {
  @extend .x-small-regular;
  @extend .gray-400;

  @media (max-width: $md) {
    margin-right: 26px;
  }
}

.item-value {
  @extend .body-bold;
  @extend .gray-600;
  text-align: right;
}

.item-value-info {
  @extend .x-small-semibold;
  @extend .gray-400;
  text-align: right;
}

</style>
